export default "__VITE_ASSET__z4bOS3u6__"